export const LocalStorageTypes = {
  USERS: 'users',
}
